import { cloneDeep, first, last } from 'lodash';
import { cloneSubtitle } from '../functions';

// ***************************************************************************************
// addNewActionForUndo() est appelée que quand on déclenche un évenement
// Permet d'ajouter une nouvelle action dans l'historique des actions en arrière (undo)
// On efface la liste des actions en avant (redo)
// ***************************************************************************************
export function addNewActionForUndo(actionType) {
  const action = {
    undo: {
      id: this.subtitle.id,
      actionType,
      subtitle: cloneSubtitle(this.subtitle),
      currentWordIndex: this.currentWordIndex,
      currentLineIndex: this.currentLineIndex,
      currentLetterIndex: this.currentLetterIndex,
      underSelection: this.underSelection,
    },
    redo: undefined,
  };

  if (this.underSelection) {
    action.undo.wordsToSelect = this.wordsToSelect;
    action.undo.lettersToSelect = this.lettersToSelect;
  }

  if (this.props.search) {
    action.undo.search = this.props.search;
  }

  this.props.addNewActionForUndo(action);
}

// ***************************************************************************************
// updateSubtitleAfterUndoOrRedo permet de mettre à jour le canvas après l'undo/redo
// ***************************************************************************************
export function updateSubtitleAfterUndoOrRedo(action, active = true) {
  if (this.state.active !== undefined) {
    this.setState({ active });
  }

  if (this.active !== undefined) {
    this.active = active;
  }

  if (active) {
    this.currentLineIndex = action.currentLineIndex ?? 0;
    this.currentWordIndex = action.currentWordIndex ?? 0;
    this.currentLetterIndex = action.currentLetterIndex ?? 0;
    this.underSelection = action.underSelection ?? false;

    if (action.underSelection) {
      this.wordsToSelect = action.wordsToSelect;
      this.lettersToSelect = action.lettersToSelect;
    }
  }

  /*if (action.search && this.wordsSearchedToHightlight) {
    this.drawHightlightSearchedWord(action.search.wordsToSearch[action.search.currentPosition]);
  }*/

  this.onRefreshCanvas();
}

// ***************************************************************************************
// onUndoOrRedo permet de revenir en arrière ou d'annuler le retour en arrière
// ***************************************************************************************
export function onUndoOrRedo(key) {
  let action = key === 'UNDO' ? last(this.props.undo) : first(this.props.redo);
  if (!action) {
    return;
  }

  if (key === 'UNDO') {
    if (action.undo.subtitles) {
      if (!action.redo) {
        action.redo = {
          ...action.undo,
        };
      }

      this.props.onUndoOrRedo(key, action);

      return;
    }

    action.redo = {
      id: action.undo.id,
      actionType: action.undo.actionType,
      subtitle: cloneSubtitle(this.subtitle),
      currentWordIndex: this.currentWordIndex,
      currentLineIndex: this.currentLineIndex,
      currentLetterIndex: this.currentLetterIndex,
      underSelection: this.underSelection,
    };

    if (this.props.search) {
      action.redo.search = this.props.search;
    }

    if (this.underSelection) {
      action.undo.wordsToSelect = this.wordsToSelect;
      action.undo.lettersToSelect = this.lettersToSelect;
    }
  }

  this.props.onUndoOrRedo(key, action);
}

// ***************************************************************************************
// cancelUndo permet d'annuler l'ajout de l'undo
// ***************************************************************************************
export function cancelUndo() {
  this.props.undo.pop();
}

// ***************************************************************************************
// permet d'ajouter les sous-titres dans l'undo et redo
// ***************************************************************************************
export function addSubtitlesToUndoOrRedo(
  actionType,
  oldSubtitles,
  oldId,
  newSubtitles,
  newId
) {
  const action = {
    undo: {
      actionType,
      subtitles: cloneDeep(oldSubtitles),
      currentSubtitleId: oldId,
    },
    redo: {
      actionType,
      subtitles: cloneDeep(newSubtitles),
      currentSubtitleId: newId,
    },
  };

  this.props.addNewActionForUndo(action);
}